import * as React from "react";

export default interceptor => Component => props => {
  const newProps = interceptor(props);
  return <Component {...newProps} />;
};
